type TranslateFn = (key: string, options?: { [key: string]: any }) => string;

const defaultCompanySizeLabels: Record<number, string> = {
  1: "1-15 employees",
  16: "16-100 employees",
  101: "101-500 employees",
  501: "501-1000 employees",
  1001: "1001+ employees",
};

const companySizeTranslationKeys: Record<number, string> = {
  1: "resources.companies.sizes.one_to_fifteen_employees",
  16: "resources.companies.sizes.sixteen_to_one_hundred_employees",
  101: "resources.companies.sizes.one_hundred_one_to_five_hundred_employees",
  501: "resources.companies.sizes.five_hundred_one_to_one_thousand_employees",
  1001: "resources.companies.sizes.one_thousand_one_or_more_employees",
};

export const getTranslatedCompanySizeLabel = (
  size: { id: number; name: string },
  translate: TranslateFn,
) => {
  const defaultLabel = defaultCompanySizeLabels[size.id];
  const translationKey = companySizeTranslationKeys[size.id];
  if (!defaultLabel || !translationKey || size.name !== defaultLabel) {
    return size.name;
  }

  return translate(translationKey, { _: size.name });
};
